import CurrentRecommendation from "./current-recommendation";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-xl font-semibold text-[#111827]">
          Recommendations
        </h3>
        <CurrentRecommendation />
      </div>
    </div>
  );
};

export default Offers;
